<script lang="ts">
    import { onMount } from "svelte";
    import "../../node_modules/maplibre-gl/dist/maplibre-gl.css";
    import Navbar from "./ScenarioNavbar.svelte";
    import { ScenarioManager } from "./ScenarioManager";
    import Test from "./test/Test.svelte";
    import type { ScenarioManagerOptions } from "./ScenarioManagerOptions";
    import Head from "../header/Head.svelte";
    import LanguageSwitchAlert from "../header/language/LanguageSwitchAlert.svelte";
    import Edit from "./edit/Edit.svelte";
    import { appManager } from "../AppManager";

    export let id: string = "";

    let managerOptions: ScenarioManagerOptions = {
        mapillaryApiKey: "MLY|6618708671521882|e7a60a6233c47da05c25aa7dfc6672bf",
        maptilerApiKey: "OZUCIh4RNx38vXF8gF4H",
        profiles: appManager.profiles,
    };
    let manager: ScenarioManager = new ScenarioManager(managerOptions, id);
    let view = manager.getViewStore();

    onMount(async () => {
        await manager.initialize();
    });
</script>

<Head />
<svelte:head>
    <title>ANYWAYS</title>
</svelte:head>
<div class="full">
    <div id="header">
        <LanguageSwitchAlert />
        <Navbar {manager}/>
    </div>
    <div id="content" class="container-fluid mx-0 px-0">
        <div class="row h-100 m-0 p-0 {$view === 'test' ? '' : 'd-none'}">
            <Test manager={manager.getTestManager()}/>
        </div>
        <div class="row h-100 m-0 p-0 gx-0 {$view === 'edit' ? '' : 'd-none'}">
            <Edit manager={manager.getEditManager()} />
        </div>
    </div>
</div>

<style>
    .full {
        display: flex;
        flex-direction: column;
        height: 100%;
    }
    #header {
        flex: 0 1 auto;
    }
    #content {
        flex: 1;
        min-width: 0;
        min-height: 0;
    }
</style>
